module.exports = __webpack_public_path__ + "img/michaltim.3eb595a8.jpg";